function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconCheckFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M11.37 25.712c-.37 0-.725-.147-.987-.41l-7.532-7.53 1.975-1.976 6.544 6.544L27.174 6.536l1.976 1.975-16.792 16.792c-.262.262-.618.41-.988.41z",
    fill: props.color
  }));
}

export default SvgIconCheckFilled;